import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloud2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-2"><path d="M9.9502 4.35999C11.6082 4.36005 13.0809 5.14853 14.0176 6.36975C14.43 6.23031 14.8716 6.15397 15.3311 6.15393C17.5954 6.15393 19.4316 7.99015 19.4316 10.2545C19.4316 10.5775 19.3929 10.8915 19.3223 11.193C21.0154 11.6973 22.25 13.2657 22.25 15.1227C22.2499 17.3161 20.5274 19.1074 18.3613 19.2174L18.1504 19.2223H6.875C4.04454 19.2223 1.75 16.9277 1.75 14.0973C1.75008 11.9951 3.01621 10.1895 4.82715 9.39905C4.87304 6.60824 7.14845 4.35999 9.9502 4.35999Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCloud2;
